/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';

import { CloseMobile } from '@/icons/index';

import Button from '../../Button/Button';

import styles from './ErrorModal.module.scss';

const ErrorModal = ({
  active = false,
  setActive = () => null,
  className = '',
  classNameInner = '',
  children = '',
  icon = '',
  isInsufficient = '',
}) => {
  const closeModal = (event) => {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };
  const { t } = useTranslation();

  React.useEffect(() => {
    document.addEventListener('keydown', closeModal);

    return () => {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);

  return (
    <div
      className={classNames([
        styles.wrap,
        { [styles.open]: active },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={classNames([styles.errorInner, classNameInner])}>
        <div className={styles.errorContent}>
          <div className={styles.close} onClick={() => setActive(false)}>
            <CloseMobile />
          </div>
          {icon && (
            <Image
              className={styles.icon_img}
              src={icon}
              alt={t('cabinet:common.Error')}
              title={t('cabinet:common.Error')}
              loading='lazy'
              width={64}
              height={64}
            />
          )}
          <h2 className={styles.errorText}>{t('cabinet:common.Error')}</h2>
          <h6 className={`soft ${styles.title}`}>{children}</h6>

          <Button
            onClick={() => {
              setActive(false);
            }}
            className={styles.close_btn}
          >
            {!isInsufficient
              ? t('esim:checkout.actions.close')
              : t('cabinet:common.TopUp')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
